export default "/bundles/assets/user_a3a9fb7b40cc4aa4d0a4be6cceb7acf4.png";